import isEmpty from "../lib/isEmpty";

// const emailRegex =
//   /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/;
// const passwordRegex = /^(?=.\d)(?=.[A-Z])(?=.[a-z])(?=.\W).{6,18}(?!\S)$/;

export const registerValidation = (reqBody) => {
  const emailRegex =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/;
  const passwordRegex =
    /(?=^.{8,}$)(?=.{0,}[A-Z])(?=.{0,}[a-z])(?=.{0,}\W)(?=.{0,}\d)/g;
  let errors = {};

  if (isEmpty(reqBody.email)) {
    errors.email = "Email is required";
  } else if (!emailRegex.test(reqBody.email)) {
    errors.email = "Email is invalid";
  }

  if (isEmpty(reqBody.password)) {
    errors.password = "Password is required";
  } else if (!passwordRegex.test(reqBody.password)) {
    errors.password = "Password is invalid";
  }

  if (!isEmpty(errors)) {
    return {
      status: false,
      errors,
    };
  }

  return { status: true };
};

export const changePasswords = (reqBody) => {
  const passwordRegex =
    /(?=^.{8,}$)(?=.{0,}[A-Z])(?=.{0,}[a-z])(?=.{0,}\W)(?=.{0,}\d)/;
  let errors = {};

  if (isEmpty(reqBody.oldPassword)) {
    errors.oldPassword = "Old password is required";
  } else if (!passwordRegex.test(reqBody.oldPassword)) {
    errors.oldPassword = "Old password is invalid";
  }

  if (isEmpty(reqBody.newPassword)) {
    errors.newPassword = "New password is required";
  } else if (!passwordRegex.test(reqBody.newPassword)) {
    errors.newPassword = "New password is invalid";
  }

  if (isEmpty(reqBody.confirmPassword)) {
    errors.confirmPassword = "Confirm password is required";
  } else if (reqBody.newPassword !== reqBody.confirmPassword) {
    errors.confirmPassword = "Confirm password does not match new password";
  }

  if (!isEmpty(errors)) {
    return {
      status: false,
      errors,
    };
  }

  return { status: true };
};
